import { Popover } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import PropTypes from 'prop-types'
import { Paper } from '@components'
import { ErrorsList } from './errors/ErrorsList'
import { TYPE_ERROR, TYPE_INFO, TYPE_WARNING } from './errors/ErrorsUtil'

const useStyles = makeStyles(() => ({
  popover: {
    pointerEvents: 'none',
  },
  popoverContent: {
    pointerEvents: 'none',
  },
  paper: {
    padding: '5px 10px',
    maxWidth: 430,
  },
}))

const ANCHOR_ORIGIN = {
  vertical: 'bottom',
  horizontal: 'left',
}

const TRANSFORM_ORIGIN = {
  vertical: 'top',
  horizontal: 'left',
}

export function ErrorPopover({ errorsByType, open, anchorEl, handlePopoverClose, value, fieldId }) {
  const classes = useStyles()
  const hasItems =
    errorsByType[TYPE_ERROR].length ||
    errorsByType[TYPE_WARNING].length ||
    errorsByType[TYPE_INFO].length

  if (!hasItems) {
    return null
  }

  return (
    <Popover
      open={open}
      className={classes.popover}
      classes={{
        paper: classes.popoverContent,
      }}
      anchorEl={anchorEl}
      anchorOrigin={ANCHOR_ORIGIN}
      transformOrigin={TRANSFORM_ORIGIN}
      onClose={handlePopoverClose}
      disableRestoreFocus
    >
      <Paper className={classes.paper}>
        <ErrorsList type="error" errors={errorsByType.error} value={value} fieldId={fieldId} />
        <ErrorsList type="warning" errors={errorsByType.warning} />
        <ErrorsList type="info" errors={errorsByType.info} />
      </Paper>
    </Popover>
  )
}

ErrorPopover.propTypes = {
  errorsByType: PropTypes.shape({
    [TYPE_ERROR]: PropTypes.arrayOf(PropTypes.object),
    [TYPE_WARNING]: PropTypes.arrayOf(PropTypes.object),
    [TYPE_INFO]: PropTypes.arrayOf(PropTypes.object),
    error: PropTypes.arrayOf(PropTypes.object),
    warning: PropTypes.arrayOf(PropTypes.object),
    info: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  handlePopoverClose: PropTypes.func.isRequired,
  value: PropTypes.any,
  fieldId: PropTypes.number,
}
